(function () {
  'use strict';

  /* ── Add to cart ── */
  function addToCart(variantId) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
        }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gjones-quick-add', cartData: data });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return data;
      });
  }

  var SUCCESS_ICON = '<span class="gjones-success-icon"><svg width="16" height="16" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="9" r="8"/><polyline points="5.5,9 7.5,11.5 12.5,6.5"/></svg></span>';

  /* ── Helpers ── */
  function getProductData(card) {
    var el = card.querySelector('[data-product-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getActiveColor(card, pd) {
    if (pd.colorOptionIndex === null) return null;
    var active = card.querySelector('.gjones-card__swatch--active');
    if (active) return active.getAttribute('data-color');
    return pd.variants[0] ? pd.variants[0].options[pd.colorOptionIndex] : null;
  }

  function getSizesForColor(pd, activeColor) {
    var variants = pd.variants;
    if (pd.colorOptionIndex !== null && activeColor) {
      variants = variants.filter(function (v) { return v.options[pd.colorOptionIndex] === activeColor; });
    }
    var seen = [], result = [];
    variants.forEach(function (v) {
      var size = pd.sizeOptionIndex !== null ? v.options[pd.sizeOptionIndex] : null;
      var key = size || v.id;
      if (seen.indexOf(key) !== -1) return;
      seen.push(key);
      result.push({ id: v.id, size: size, available: v.available });
    });
    return result;
  }

  /* ── Size bar: injected inside the overlay div, shown on overlay:hover via CSS ── */
  function buildSizeBar(card, pd, activeColor) {
    var overlay = card.querySelector('.gjones-card__quick-add-overlay');
    if (!overlay) return;

    var bar = overlay.querySelector('.gjones-grid3__size-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'gjones-grid3__size-bar';
      overlay.appendChild(bar);
    }
    bar.innerHTML = '';

    var sizes = getSizesForColor(pd, activeColor);

    if (pd.sizeOptionIndex === null) {
      /* Color-only or single-variant: one ADD TO BAG button */
      var v = sizes[0];
      if (!v) return;
      var btn = document.createElement('button');
      btn.className = 'gjones-grid3__size-btn gjones-grid3__size-btn--single' + (v.available ? '' : ' is-sold-out');
      btn.disabled = !v.available;
      btn.setAttribute('data-variant-id', v.id);
      btn.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
      bar.appendChild(btn);
    } else {
      sizes.forEach(function (v) {
        var btn = document.createElement('button');
        btn.className = 'gjones-grid3__size-btn' + (v.available ? '' : ' is-sold-out');
        btn.disabled = !v.available;
        btn.setAttribute('data-variant-id', v.id);
        btn.textContent = v.size;
        bar.appendChild(btn);
      });
    }
  }

  /* ── Size button click → direct add to cart ── */
  function initSizeBar(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.gjones-grid3__size-btn');
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!vid) return;
      var orig = btn.innerHTML;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="gjones-spinner" style="width:12px;height:12px;border-width:1.5px"></span>';
      addToCart(vid).then(function () {
        btn.innerHTML = SUCCESS_ICON;
        setTimeout(function () { btn.innerHTML = orig; btn.classList.remove('is-loading'); }, 1400);
      }).catch(function () {
        btn.innerHTML = orig;
        btn.classList.remove('is-loading');
      });
    });
  }

  /* ── Swatches: update size bar on colour change ── */
  function initSwatches(section) {
    section.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      var card = swatch.closest('.gjones-card');
      if (!card) return;
      var pd = getProductData(card);
      if (!pd) return;
      var color = swatch.getAttribute('data-color');
      var imageUrl = swatch.getAttribute('data-image');

      var swatchGroup = swatch.closest('[data-swatches]');
      if (swatchGroup) swatchGroup.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('gjones-card__swatch--active'); });
      swatch.classList.add('gjones-card__swatch--active');

      if (imageUrl) {
        var img = card.querySelector('.gjones-card__img--primary');
        if (img) { img.src = imageUrl; img.srcset = ''; }
      }

      buildSizeBar(card, pd, color);
    });
  }

  /* ── Wishlist ── */
  var WISHLIST_KEY = 'gjones-wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; } }
  function saveWishlist(l) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(l)); }
  function toggleWishlist(handle) {
    var list = getWishlist(), idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1;
  }

  function initWishlist(section) {
    section.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (getWishlist().indexOf(btn.getAttribute('data-product-handle')) !== -1) btn.classList.add('is-active');
    });
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      btn.classList.toggle('is-active', toggleWishlist(btn.getAttribute('data-product-handle')));
    });
  }

  /* ── Mobile bottom sheet ── */
  var sheetEl = null;

  function ensureSheet() {
    if (sheetEl) return sheetEl;
    sheetEl = document.createElement('div');
    sheetEl.className = 'gjones-grid3-sheet';
    sheetEl.setAttribute('aria-modal', 'true');
    sheetEl.setAttribute('role', 'dialog');
    sheetEl.innerHTML =
      '<div class="gjones-grid3-sheet__panel">' +
        '<div class="gjones-grid3-sheet__header">' +
          '<span class="gjones-grid3-sheet__title">Quick Add</span>' +
          '<button class="gjones-grid3-sheet__close" aria-label="Close">' +
            '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="1" y1="1" x2="11" y2="11"/><line x1="11" y1="1" x2="1" y2="11"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="gjones-grid3-sheet__body" data-grid3-body></div>' +
      '</div>';
    document.body.appendChild(sheetEl);

    sheetEl.querySelector('.gjones-grid3-sheet__close').addEventListener('click', closeSheet);
    sheetEl.addEventListener('click', function (e) { if (e.target === sheetEl) closeSheet(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheetEl.classList.contains('is-active')) closeSheet();
    });

    sheetEl.addEventListener('click', function (e) {
      /* Size row */
      var row = e.target.closest('[data-grid3-size-row]');
      if (row && !row.classList.contains('is-sold-out')) {
        var vid = parseInt(row.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        var nameEl = row.querySelector('.gjones-grid3-sheet__size-name');
        var orig = nameEl ? nameEl.innerHTML : '';
        if (nameEl) nameEl.innerHTML = '<span class="gjones-spinner" style="width:13px;height:13px;border-width:1.5px"></span>';
        row.style.pointerEvents = 'none';
        addToCart(vid).then(function () {
          if (nameEl) nameEl.innerHTML = SUCCESS_ICON;
          setTimeout(function () { closeSheet(); }, 900);
        }).catch(function () {
          if (nameEl) nameEl.innerHTML = orig;
          row.style.pointerEvents = '';
        });
        return;
      }
      /* Single-variant ATC */
      var atcBtn = e.target.closest('[data-grid3-single-atc]');
      if (atcBtn && !atcBtn.disabled) {
        var vid2 = parseInt(atcBtn.getAttribute('data-variant-id'), 10);
        if (!vid2) return;
        var orig2 = atcBtn.innerHTML;
        atcBtn.innerHTML = '<span class="gjones-spinner" style="width:14px;height:14px;border-width:2px;border-color:rgba(255,255,255,.3);border-top-color:#fff"></span>';
        atcBtn.disabled = true;
        addToCart(vid2).then(function () {
          atcBtn.innerHTML = SUCCESS_ICON;
          setTimeout(function () { closeSheet(); }, 900);
        }).catch(function () {
          atcBtn.innerHTML = orig2;
          atcBtn.disabled = false;
        });
      }
    });

    return sheetEl;
  }

  function openSheet(card) {
    var sheet = ensureSheet();
    var pd = getProductData(card);
    if (!pd) return;
    var activeColor = getActiveColor(card, pd);
    var sizes = getSizesForColor(pd, activeColor);
    var body = sheet.querySelector('[data-grid3-body]');
    body.innerHTML = '';

    if (pd.sizeOptionIndex === null) {
      var v = sizes[0];
      if (!v) return;
      var btn = document.createElement('button');
      btn.className = 'gjones-grid3-sheet__single-atc';
      btn.setAttribute('data-grid3-single-atc', '');
      btn.setAttribute('data-variant-id', v.id);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
      body.appendChild(btn);
    } else {
      sizes.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'gjones-grid3-sheet__size-row' + (v.available ? '' : ' is-sold-out');
        row.setAttribute('data-grid3-size-row', '');
        row.setAttribute('data-variant-id', v.id);
        row.innerHTML =
          '<span class="gjones-grid3-sheet__size-name">' + (v.size || '') + '</span>' +
          (v.available ? '<span class="gjones-grid3-sheet__size-add">Add</span>' : '<span class="gjones-grid3-sheet__size-add">Sold out</span>');
        body.appendChild(row);
      });
    }

    sheet.classList.add('is-active');
  }

  function closeSheet() {
    if (!sheetEl) return;
    sheetEl.classList.remove('is-active');
  }

  function initMobile(section) {
    section.addEventListener('click', function (e) {
      var mobileBtn = e.target.closest('.gjones-card__quick-add-mobile[data-quick-add-mobile]');
      if (mobileBtn) {
        e.preventDefault();
        e.stopPropagation();
        var card = mobileBtn.closest('.gjones-card');
        if (card) openSheet(card);
        return;
      }
      var directBtn = e.target.closest('.gjones-card__quick-add-mobile[data-quick-add-direct]');
      if (directBtn) {
        e.preventDefault();
        e.stopPropagation();
        var vid = parseInt(directBtn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        addToCart(vid).catch(function () {});
      }
    });
  }

  /* ── Slider ── */
  function getScrollAmount(track) {
    var firstCard = track.firstElementChild;
    if (!firstCard) return track.offsetWidth;
    var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return firstCard.offsetWidth + gap;
  }

  function updateArrows(slider, loop) {
    var track = slider.querySelector('[data-slider-track]');
    var prevBtn = slider.querySelector('[data-slider-prev]');
    var nextBtn = slider.querySelector('[data-slider-next]');
    if (!track) return;
    if (loop) {
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
      return;
    }
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;
  }

  function initSlider(slider) {
    var track = slider.querySelector('[data-slider-track]');
    var prevBtn = slider.querySelector('[data-slider-prev]');
    var nextBtn = slider.querySelector('[data-slider-next]');
    if (!track) return;

    var loop = slider.getAttribute('data-slider-loop') === 'true';
    var autoplay = slider.getAttribute('data-slider-autoplay') === 'true';
    var autoplaySpeed = parseInt(slider.getAttribute('data-slider-autoplay-speed'), 10) || 5;

    function goNext() {
      var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
      if (atEnd && loop) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
      }
    }

    function goPrev() {
      var atStart = track.scrollLeft <= 1;
      if (atStart && loop) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { updateArrows(slider, loop); }, 50);
    });

    updateArrows(slider, loop);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { updateArrows(slider, loop); }, 100);
    });

    if (autoplay) {
      var autoplayTimer = setInterval(goNext, autoplaySpeed * 1000);
      slider.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
      slider.addEventListener('mouseleave', function () {
        clearInterval(autoplayTimer);
        autoplayTimer = setInterval(goNext, autoplaySpeed * 1000);
      });
    }
  }

  /* ── Section init ── */
  function initSection(section) {
    if (section.hasAttribute('data-slider')) {
      initSlider(section);
    }

    section.querySelectorAll('.gjones-card').forEach(function (card) {
      var pd = getProductData(card);
      if (!pd) return;
      buildSizeBar(card, pd, getActiveColor(card, pd));
    });

    initSizeBar(section);
    initSwatches(section);
    initWishlist(section);
    initMobile(section);
  }

  /* ── Boot ── */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.gjones-product-grid--layout-3').forEach(initSection);

    /* Watch for AJAX-loaded product-recommendations containing layout-3 grids */
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      var obs = new MutationObserver(function (mutations, observer) {
        var hasNodes = mutations.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1; });
        });
        if (!hasNodes) return;
        observer.disconnect();
        el.querySelectorAll('.gjones-product-grid--layout-3').forEach(initSection);
      });
      obs.observe(el, { childList: true });
    });
  });
})();
